import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client.service';
import {Observable} from 'rxjs/Observable';
import {GetHistoryRequest} from '../../types/api-request/document/getHistory';
import {IDocumentHistory} from '../../types/api-response/document';
import {ApiResponseList} from '../../types/api-response/helpers';
import {map} from 'rxjs/operators';

@Injectable()
export class DocumentApiService {

    constructor(
        private api: ApiClientService
    ) {
    }

    getPermissions(permissions: string[] = []): Observable<string[]> {
        const queryParams = permissions.map(permissionName => `permission[]=${permissionName}`).join('&');
        return this.api.getJson('domainDocuments', `/api/v1/permissions?${queryParams}`);
    }

    getHistory(params: GetHistoryRequest): Observable<ApiResponseList<IDocumentHistory>> {
        const queryParams = ApiClientService.serialize(params);
        return this.api.getJson('domainDocuments', `/api/v1/history.json${queryParams}`)
            .pipe(
                map(response => {
                    if (Array.isArray(response)) {
                        return {entities: response, total: response.length};
                    }
                    return response;
                })
            );
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/api/document-api.service.ts